import axiosClient from "../../../../../../../system/helpers/axiosConfig";

export const getStylesList = () => {
  return axiosClient
    .get(`/api/admin/notifications/global-notification-styles`)
    .then((r) => r.data);
};
